import React from 'react';
import style from './styles.module.css';
import classNames from 'classnames';
type Props = {
  className?: string | 'grid' | 'switch' | 'footer' | 'column' | 'modal' | 'flex';
  children: React.ReactNode;
  disabled?: boolean;
};

export const FormField = ({ className = '', children, disabled = false }: Props) => {
  const styles = classNames(style.field, style[className], {
    [style.disabled]: disabled,
  });
  return <div className={styles}>{children}</div>;
};
